import { gql } from "@/__generated__/gql";

/**
 * What a widget comes to, whatever it is of.
 *
 * There used to be a fragment per construct and presentation pair - fourteen
 * of them, each naming a GraphQL type of its own - so a new kind of widget
 * meant editing this document too. A widget now answers in one of four
 * shapes, and this asks for all four.
 */
export const REPORT_WIDGET_CONTENT_QUERY = gql(`
  query ReportWidgetContent(
    $id: ID!
    $timeframeFilterSet: SharedReportTimeframeFilterSetInput
  ) {
    node(id: $id) {
      ... on ReportWidgetObject {
        identifier
        source
        presentation
        data(filterSet: $timeframeFilterSet) {
          ...ReportWidgetShape
        }
      }
    }
  }
`);
